/**
 * @ngdoc directive
 * @name directiveAdvancedSearch
 * @restrict A
 *
 * @description
 * Directive for advanced search.
 */
export default function () {
    return {
        restrict: 'A', // Only attribute name can be used for directive definition
        scope: {},
        controller: 'directiveAdvancedSearchCtrl' // Executes before compile
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/advancedSearch.js